'use client';

import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { Cookies } from 'src/api/Cookies';
import useApi from './useApi';
import { getSameOriginBaseURL } from 'src/utils/environment';
interface MutationsParams {
  name: string;
  value: string;
  options?: {
    httpOnly?: boolean;
    secure?: boolean;
    sameSite?: 'lax' | 'strict' | 'none';
    maxAge?: number;
  };
}
const useCookies = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getSameOriginBaseURL();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const baseURL = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      baseURL
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cookies = useApi(Cookies, t1);
  let t2;
  if ($[2] !== cookies) {
    t2 = {
      mutationFn: async t3 => {
        const {
          name,
          value,
          options
        } = t3;
        return await cookies.set({
          name,
          value,
          options: {
            httpOnly: true,
            secure: process.env.NODE_ENV === "production",
            sameSite: "lax",
            maxAge: 604800,
            ...options
          }
        });
      }
    };
    $[2] = cookies;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    mutateAsync: setCookie,
    isPending: isSettingCookie
  } = useMutation(t2);
  let t3;
  if ($[4] !== cookies) {
    t3 = {
      mutationFn: async name_0 => await cookies.delete(name_0)
    };
    $[4] = cookies;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    mutateAsync: deleteCookie,
    isPending: isDeletingCookie
  } = useMutation(t3);
  const t4 = isSettingCookie || isDeletingCookie;
  let t5;
  if ($[6] !== deleteCookie || $[7] !== setCookie || $[8] !== t4) {
    t5 = {
      setCookie,
      isLoading: t4,
      deleteCookie
    };
    $[6] = deleteCookie;
    $[7] = setCookie;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default useCookies;